"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var headersDetail_1 = require("./headersDetail");
var bulkEdit_1 = require("./bulkEdit");
var HeadersList = function (props) { return (React.createElement("thead", null,
    React.createElement("tr", { className: "EditableList__Headers" },
        props.inBulkEditMode && (React.createElement(bulkEdit_1.RowSelectorHeader, { areAllChecked: props.areAllRowsSelected, onClick: props.onClickSelectHeader })),
        props.headers.map(function (header, index) { return (React.createElement(headersDetail_1.default, { click: props.onClickSortHeader, column: props.columns[index], header: header })); })))); };
exports.default = HeadersList;
